
import { Task, TaskStatus } from './types';

export const mapSupabaseTaskToTask = (task: any, index?: number): Task => ({
  id: task.id,
  title: task.title,
  detail: task.detail,
  status: task.status as TaskStatus || 'to-do',
  created_at: task.created_at,
  dateCreated: task.created_at ? new Date(task.created_at) : new Date(),
  user_id: task.user_id,
  list_id: task.list_id,
  totalTimeSpent: task.total_time_spent || 0,
  pomodorosCompleted: task.pomodoros_completed || 0,
  is_active: task.is_active || false,
  position: task.position ?? (index ?? 0),
  priority_quadrant: task.priority_quadrant,
  priority_x: task.priority_x,
  priority_y: task.priority_y
});

export const mapTaskToSupabaseTask = (task: Task, userId: string) => ({
  id: task.id,
  title: task.title,
  detail: task.detail,
  status: task.status,
  created_at: task.created_at,
  list_id: task.list_id,
  user_id: userId,
  total_time_spent: task.totalTimeSpent,
  pomodoros_completed: task.pomodorosCompleted,
  position: task.position,
  priority_quadrant: task.priority_quadrant,
  priority_x: task.priority_x,
  priority_y: task.priority_y
});

export const sortTasksByStatus = (tasks: Task[]) => {
  const groupedTasks = {
    'to-do': tasks.filter(t => t.status === 'to-do').sort((a, b) => a.position - b.position),
    'in-progress': tasks.filter(t => t.status === 'in-progress').sort((a, b) => a.position - b.position),
    'done': tasks.filter(t => t.status === 'done').sort((a, b) => a.position - b.position)
  };
  
  return [
    ...groupedTasks['to-do'],
    ...groupedTasks['in-progress'],
    ...groupedTasks['done']
  ];
};

export const calculateNewPosition = (tasks: Task[], status: TaskStatus, listId: string): number => {
  const statusTasks = tasks.filter(t => t.status === status && t.list_id === listId);
  return statusTasks.length > 0 
    ? Math.max(...statusTasks.map(t => t.position)) + 1
    : 0;
};
